import React from 'react';
import { translate } from '../../../../utils/translate';
import { CreateBanner } from './CreateBanner';

const IMAGE = {
    LG: 'https://fiverr-res.cloudinary.com/image/upload/f_auto,q_auto/v1/attachments/generic_asset/asset/d0d3c809dc3e49d15e0eb0448d7a026c-1732794882459/sign-business-team-banner.png',
};

interface TeamBannerProps {
    title?: string;
}

export const TeamBanner: React.FC<TeamBannerProps> = ({ title }) => (
    <CreateBanner imageSrcMd="" imageSrcLg={IMAGE.LG} title={title || translate('image_banner.business_info_title')} />
);

export const TeamBannerInvitation: React.FC<TeamBannerProps> = () => (
    <CreateBanner imageSrcMd="" imageSrcLg={IMAGE.LG} title={translate('image_banner.invitation_title')} />
);
